export interface UserAttributes {
  department: string;
  faculty: string;
  name: string;
  surname:string;
  email: string;
  userId: string;
  rank: string;
  secondInCharge: string;
  yearsOfExperience: number;
  university: string;
  token: string;
  roles: Roles[];
}

export enum Roles {
  HOD = 'HOD',
  DEAN = 'dean',
  ADMIN = 'admin',
  FINANCE = 'finance',
  STUDENT = 'student',
  OVERVIEWER = 'overviewer',
  FIRST_APPROVER = 'first_approver',
  SECOND_APPROVER = 'second_approver',
  THIRD_APPROVER = 'third_approver',
  USER_ROLE_MANAGER = 'user_role_manager',
  UNIVERSITY_MANAGER = 'university_manager'
}

export enum Ranks{
  assistant_admin,
  admin_officer,
  senior_admin,
  chief_admin,
}
